import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PriorityService {

    api_url = environment.url;
    constructor(private http: HttpClient) { }

    getData() {
        return this.http.get(`${this.api_url}priority`)
    }
}
